export function ProfileCompletionIcon() {
  return (
    <svg width="29" height="29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.8 22.6l-.2.4-4.4-.8a54.5 54.5 0 00-.3-1.6c-.3-.9-.5-2-.8-2.4v0-.1c-.8-1.5-1.5-3-1.2-4.7a5.9 5.9 0 016.7-4.7c3.2.5 5.3 3.5 4.7 6.7v0a7 7 0 01-2 3.5 23.4 23.4 0 00-2.5 3.7z" fill="#ABB2EB" stroke="#000" />
      <path d="M12.6 22.6L13 13s-2.3-.4-2 1.2c.4 1.7 1.2 1.9 1.2 1.9s3.4.1 3.6-2c.2-2-1-2-1.2-1.5-.2.5-.5 3.7 0 4.1.6.4 3.7.9 4.2-1.3.6-2.3-1.3-2.7-1.6-2-.3.5-3.1 9.5-3.1 9.5" stroke="#fff" />
      <path d="M15.6 23.8L11 23a.5.5 0 00-.6.4h0a.5.5 0 00.4.6h.1v.2h0a.4.4 0 00.3.6l3.8.6a.4.4 0 00.5-.3V25v-.2a.5.5 0 00.6-.4h0a.5.5 0 00-.5-.6z" fill="#fff" stroke="#24286B" />
      <path d="M14.2 26.2l-2.7-.5c-.2 0-.3-.2-.3-.4v-.2c.1-.2.3-.3.5-.3l2.6.5c.2 0 .4.2.3.4v.2c0 .2-.2.3-.4.3z" fill="#24286B" />
      <path d="M7.6 11.3L2.2 9M10 7.4L6.7 3.2M14.9 7l.5-5m4 6.2l2.5-3.4m0 6.9l3.5-1.4M22 14.7l3 .3m-17.3-.4l-3.3-.1" stroke="#ABB2EB" />
    </svg>
  );
}
